import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './accountSimplifiedHeader.module.scss';

const AccountSimplifiedHeader = () => {
  const tLabels = useTranslation("accounts\\accounts").t;

  return (
    <div className="d-none d-sm-block mb-2 text-muted font-weight-bold">
      <div className={`row no-gutters align-items-center px-3 ${styles.header}`}>
        <div className="col-sm-5">
          {tLabels("accountSimplifiedHeader.email")}
        </div>
        <div className="col-sm-4 text-muted px-sm-4">
          {tLabels("accountSimplifiedHeader.role")}
        </div>
        <div className="col-sm-3">
          {tLabels("accountSimplifiedHeader.restriction")}
        </div>
      </div>
    </div>
  );
}

export default AccountSimplifiedHeader;
